import BenchlingConfig from 'BenchlingConfig';
import StructuredTableSettingsModal from 'notebook/structured-tables/components/modals/StructuredTableSettingsModal';
import {StructuredTableMetadata} from 'notebook/structured-tables/StructuredTableConstants';
import updateStructuredTableMetadata from 'notebook/structured-tables/util/updateStructuredTableMetadata';
import {TableOpFunction, TableOpOptions} from 'notebook/tables/excess/ops/TableOpConstants';
import runModal from 'ui-library/runModal';

import {ToolbarButtonActionFunction} from '../StructuredTableConstants';
import makeSimpleActionFunction from './makeSimpleActionFunction';

export function applyRowByRowSubmissionSettingsUpdate({
  performTableOpOnTable,
  values,
}: {
  performTableOpOnTable: (params: {op: TableOpFunction; options?: TableOpOptions}) => void;
  values: {rowByRowSubmissionRequired?: boolean};
}): void {
  if (values.rowByRowSubmissionRequired == null) {
    return;
  }

  updateStructuredTableMetadata<StructuredTableMetadata>({
    performTableOpOnTable,
    metadata: {rowByRowSubmissionRequired: values.rowByRowSubmissionRequired},
  });
}

export const updateStructuredTableSettingsActionFunction: ToolbarButtonActionFunction<unknown, unknown> =
  makeSimpleActionFunction({
    label: 'Settings',
    icon: 'settings',
    onInvoke: async ({structuredTable, locked, performTableOpOnTable}) => {
      const showSubmissionSetting =
        BenchlingConfig.ELN_ENABLE_ROW_ONLY_TABLE_SUBMISSION && structuredTable.isConfig;
      const settingsValues = await runModal(
        StructuredTableSettingsModal,
        {
          rowOnlyConfig: {
            showSubmissionSetting,
            rowOnlyInitialValue: structuredTable.metadata.rowByRowSubmissionRequired ?? false,
          },
          locked,
        },
        {title: 'Table settings', closeOnClickOutside: true}
      );
      if (settingsValues == null) {
        return;
      }

      applyRowByRowSubmissionSettingsUpdate({performTableOpOnTable, values: settingsValues});
    },
    getTooltip: () => 'Settings',
    getDisabled: ({isProtected}) => Boolean(isProtected),
    getHidden: ({structuredTable}) =>
      !BenchlingConfig.ELN_ENABLE_ROW_ONLY_TABLE_SUBMISSION || !structuredTable.isConfig,
  });
